<template>
  <GestionListaNegra />
</template>
<script setup>
import GestionListaNegra from "@/views/admin/listaNegra/components/GestionListaNegra.vue";
</script>
